export const columnSchema = [
  { width: 200, field: 'street', displayName: 'Street', type: 'string' },
  { width: 112, field: 'city', displayName: 'City', type: 'string' },
  { width: 80, field: 'county', displayName: 'County', type: 'string' },
  { width: 52, field: 'state', displayName: 'State', type: 'string' },
  { width: 68, field: 'zipcode', displayName: 'Zipcode', type: 'string' },
  { width: 150, field: 'latitude', displayName: 'Latitude', type: 'number' },
  { width: 150, field: 'longitude', displayName: 'Longitude', type: 'number' },
];